(
    function (skyward, $)
    {
        function init(selector)
        {
            var positionNumberLookupSearch = $(selector).find(".js-positionNumberLookupSearch");
            if (positionNumberLookupSearch.length == 0)
            {
                return;
            }

            var filterAction = positionNumberLookupSearch.data("updateBrowseAction");
            if (!filterAction)
            {
                return;
            }

            var browse = positionNumberLookupSearch.find(".browse");
            var browseName = browse.attr("id");

            browse = skyward.browse.browseList[browseName];
            if (browse.length == 0)
            {
                return;
            }

            var positionNumberLookupForm = positionNumberLookupSearch.find(".js-positionNumberLookupForm");
            if (positionNumberLookupForm.length == 0)
            {
                return;
            }

            var searchHandler = createSearchHandler(browse, filterAction);
            searchHandler.setEvents(positionNumberLookupForm);
            searchHandler.updateBrowseFromInputs(positionNumberLookupForm);
        }

        function createSearchHandler(browse, filterAction)
        {
            var _previousPostData;
            var _browseInitialFilter = browse.data.filter;
            var _browseInitialRouteHash = browse.routeHash;

            var _defaultPostData =
            {
                BrowseName: browse.browseName,
                TaskName: browse.taskName
            };

            var _getPostData = internalGetPostData;

            var searchHandler = {};
            searchHandler.setEvents = setEvents;
            searchHandler.updateBrowseFromInputs = updateBrowseFromInputs;

            return searchHandler;

            function setEvents(jqForm)
            {
                var namedInputs = jqForm.find("[name]").not(".doNotPost");
                namedInputs.each(setEvent);

                function setEvent(index, element)
                {
                    var jqElement = $(element);

                    if (jqElement.is("[type='text']") && !jqElement.is(".datepicker"))
                    {
                        jqElement.on("keydown", skyward.debounce(function () { updateBrowseFromInputs(jqForm); }));
                        return;
                    }

                    jqElement.on("change", function () { updateBrowseFromInputs(jqForm); });
                }
            }

            function updateBrowseFromInputs(jqForm)
            {
                $.when(getFilter(jqForm)).done(function (filterData)
                {
                    if (!filterData)
                    {
                        return;
                    }

                    browse.data.filter = filterData.SearchCondition ? skyward.extensions.encodeHtml(filterData.SearchCondition) : _browseInitialFilter;
                    browse.routeHash = filterData.RouteHash ? filterData.RouteHash : _browseInitialRouteHash;

                    skyward.browse.changePage(browse.browseName, { currentPage: 1 });
                });
            }

            function getFilter(jqForm)
            {
                return _getPostData(jqForm).then(postData =>
                {
                    var stringifiedPostData = JSON.stringify(postData);

                    // Guards against posting the same filter twice due to dependents or other sources
                    if (stringifiedPostData === _previousPostData)
                    {
                        var deferred = $.Deferred();
                        deferred.resolve();
                        return deferred.promise();
                    }

                    _previousPostData = stringifiedPostData;

                    return $.ajax({
                        url: skyward.global.virtualDir + filterAction,
                        type: "POST",
                        dataType: "JSON",
                        data: $.extend({}, _defaultPostData, { JsonData: stringifiedPostData })
                    });
                });
            }

            function internalGetPostData(jqForm)
            {
                return skyward.dataobjectviewer.getFieldValues(jqForm);
            }
        }
        
        //Bootstrap
        skyward.window.registerLoadDOMCallback(init);

    }(window.skyward = window.skyward || {}, window.jQuery)
);
